import AnnotationsHandler from '..';
import Stateutils from '../../store/state/utils/state-utils';

/**
 * This handler will be invoked if the property is configured as shared property.
 */
AnnotationsHandler.registerHandler('@SHARED', (property: string) => {
  return Stateutils.getSharedState(property);
});
